import { simpleHtmlPreview } from 'frontend/client-communication/components/editor/editor-helper'
import { KINDS } from 'frontend/client-communication-rules'

export const FIELDS = [
  'id',
  'name',
  'kind',
  'message_title',
  'message_body',
  'attachments_counter',
  'created_at',
  'updated_at',
]

export const SUBSCRIPTIONS = {
  items: 'ClientCommunicationTemplatesChannel',
}

export const ORGANIZATION_SUBSCRIPTIONS = {
  items: 'OrganizationClientCommunicationTemplatesChannel',
}

export const DEFAULT_COLUMNS = ['name', 'messageTitle', 'messageBody', 'kind', 'languages']

export const COLUMNS_CONFIG = {
  name: {
    label: 'Name',
    header: {
      sort: 'lowerName',
    },
    cell: {
      kind: 'simple',
      path: 'name',
    },
  },
  kind: {
    label: 'Kind',
    header: {},
    cell: {
      kind: 'function',
      fn: cct => KINDS.find(el => el.value == cct.kind)?.label,
    },
  },
  messageTitle: {
    label: 'Title [EN]',
    header: {},
    cell: {
      // kind: 'function',
      // fn: cct => {
      //   return cct.messageTitle['eng']
      // },
      kind: 'component',
      component: 'ellipsis-with-tooltip',
      componentProps: cct => ({
        text: cct.messageTitle['eng'],
        limit: 250,
      }),
    },
  },
  messageBody: {
    label: 'Body [EN]',
    header: {},
    cell: {
      kind: 'component',
      component: 'ellipsis-with-tooltip',
      componentProps: cct => ({
        text: simpleHtmlPreview(cct.messageBody['eng']),
        limit: 250,
      }),
    },
  },
  languages: {
    label: 'Languages',
    header: {},
    cell: {
      kind: 'function',
      fn: cct => {
        return Object.keys(cct.messageBody)
          .map(el => el.toUpperCase())
          .join(', ')
      },
    },
  },
  attachmentsCounter: {
    label: 'Attachments',
    header: {
      sort: 'attachmentsCounter',
    },
    cell: {
      kind: 'simple',
      path: 'attachmentsCounter',
    },
  },
  createdAt: {
    label: 'Created Datetime',
    header: {
      sort: 'createdAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({ t: el.createdAt }),
    },
  },
  createdDate: {
    label: 'Created Date',
    header: {
      sort: 'createdAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({
        t: el.createdAt,
        format: 'dateOnly',
      }),
    },
  },
  createdTime: {
    label: 'Created Time',
    header: {
      sort: 'createdAt',
    },
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({
        t: el.createdAt,
        format: 'timeOnly',
      }),
    },
  },
  updatedAt: {
    label: 'Updated Datetime',
    header: {},
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({ t: el.updatedAt }),
    },
  },
  updatedDate: {
    label: 'Updated Date',
    header: {},
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({
        t: el.updatedAt,
        format: 'dateOnly',
      }),
    },
  },
  updatedTime: {
    label: 'Updated Time',
    header: {},
    cell: {
      kind: 'component',
      component: 'formatted-time',
      componentProps: el => ({
        t: el.updatedAt,
        format: 'timeOnly',
      }),
    },
  },
}
